import { Avatar, Grid, GridProps, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';

interface IPetTitle extends GridProps {
  title: string;
  petImageUrl?: string;
  extra?: any;
}

export const PetTitle: FC<IPetTitle> = ({
  title,
  petImageUrl,
  marginTop = 0,
  marginBottom = 2,
  extra,
  ...props
}) => {
  return (
    <Grid
      item
      container
      alignItems="center"
      marginBottom={marginBottom}
      marginTop={marginTop}
      {...props}
    >
      <Grid item>
        <Typography
          display={'flex'}
          justifyContent="space-between"
          alignItems="center"
          sx={{ fontWeight: 500, fontSize: 20, pr: petImageUrl ? 1 : 2 }}
        >
          {title} {extra && extra}
        </Typography>
      </Grid>

      {petImageUrl && (
        <Grid item marginLeft={1}>
          <Avatar sx={{ width: 80, height: 80, border: '5px solid #FBB45F' }}>
            {petImageUrl}
          </Avatar>
        </Grid>
      )}

      <Grid item xs>
        <Box
          sx={{
            position: 'relative',
            ':before': {
              content: "''",
              position: 'absolute',
              top: '50%',
              left: 0,
              borderTop: '1px solid #FBB45F',
              backgroundColor: '#FBB45F',
              width: '100%',
              transform: 'translateY(-50%)',
            },
          }}
        >
          <Box
            sx={{
              p: '0 10px',
              display: 'flex',
              justifyContent: 'space-between',
              position: 'relative',
            }}
          ></Box>
        </Box>
      </Grid>
    </Grid>
  );
};
